// TODO: Ask PM maybe should use emailConfirmCredits value from useUserConfigQuery that left after experiment
export const EmailConfirmTokens = 10;
export const EmailConfirmBannerShowSecondTimeDelayMs = 7 * 24 * 60 * 60 * 1000;
export const EmailConfirmResendTimeoutMs = 2 * 60 * 1000;

export const IdHideEmailConfirmModal = 'hideEmailConfirmModal';
export const IdShowEmailConfirmModal = 'showEmailConfirmModal';
